//librerías
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

//context
import { AuthContext } from "../../../../context/AuthContext";

//componentes
import { Button, Container, Spinner } from "react-bootstrap";
import {
  faPen,
  faSquarePlus,
  faToggleOff,
  faToggleOn,
} from "@fortawesome/free-solid-svg-icons";

//interfaces
import { FuncionInterface } from "../../../../interfaces/FuncionInterface";

//hooks
import useFetch from "../../../../hooks/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import CustomTable from "../../../Formularios/CustomTable/CustomTable";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import { toast } from "react-toastify";

//estilos
const classes = require("./FuncionTable.module.css").default;

const FuncionTable = () => {
  const authContext = useContext(AuthContext);
  //variables de estado
  const [funcion, setFuncion] = useState<FuncionInterface[]>();
  const { sendRequest, error, setError } = useFetch();
  const navigate = useNavigate();

  //Función que trata los funcion traídos de la BD.
  const transformData = useCallback((variable: any) => {
    setFuncion(variable.data);
  }, []);

  //Función que llama todos los funcion paginados
  useEffect(() => {
    sendRequest(
      {
        url: "/funcion",
      },
      transformData
    );
  }, [sendRequest, transformData]);

  //Función que desactiva a un funcion.
  const changeFuncionStatus = useCallback(
    (idFuncion: number) => {
      if (
        window.confirm("¿Seguro que desea cambiar el estatus de la función?")
      ) {
        sendRequest(
          {
            url: `/funcion/${idFuncion}`,
            method: "DELETE",
          },
          (variable: any) => {
            setFuncion([]);
            toast.success("La función ha cambiado de estatus.", {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            sendRequest(
              {
                url: "/funcion",
              },
              transformData
            );
          }
        );
      }
    },
    [sendRequest, transformData]
  );

  const columns = useMemo<ColumnDef<FuncionInterface>[]>(
    () => [
      {
        header: "#",
        accessorKey: "id",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        enableColumnFilter: false,
      },
      {
        header: "Nombre",
        accessorFn: (row) => row.nombre,
        id: "nombre",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
      },
      {
        header: "Estatus",
        cell: (info) => info.getValue(),
        accessorFn: (row) => (row.estatus ? "Activo" : "Inactivo"),
      },
      {
        header: "Acciones",
        cell: (info) => (
          <div className="btn-group" role="group" aria-label="Basic example">
            <Button
              title="Editar funcion"
              style={{ backgroundColor: "#2874A6", borderColor: "white" }}
              onClick={() =>
                navigate(`/main/catalogos/funcion/edit/${info.row.original.id}`)
              }
              disabled={!authContext.tokenCan("Funcion:update")}
            >
              <FontAwesomeIcon icon={faPen} />
            </Button>
            {/** Botón para ver eliminar*/}
            <Button
              title={
                info.row.original.estatus
                  ? "Deshabilitar función"
                  : "Habilitar función"
              }
              style={{ backgroundColor: "#0d5475", borderColor: "white" }}
              disabled={!authContext.tokenCan("Funcion:delete")}
              onClick={() => changeFuncionStatus(info.row.original.id)}
            >
              <FontAwesomeIcon
                icon={info.row.original.estatus ? faToggleOn : faToggleOff}
              />
            </Button>
          </div>
        ),
        footer: (props) => props.column.id,
      },
    ],
    [changeFuncionStatus, navigate, authContext]
  );

  //Mientras se carga el contenido se muestra un spinner
  if (!funcion) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Lista de funciones</h2>
      {/** Botón para agregar usuario */}
      {authContext.tokenCan("Funcion:store") && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            title="Agregar una nueva función"
            style={{
              backgroundColor: "#21618C",
              borderColor: "white",
              marginBottom: "10px",
            }}
            onClick={() => navigate(`/main/catalogos/funcion/crear`)}
          >
            <FontAwesomeIcon icon={faSquarePlus} /> Nueva función
          </Button>
        </div>
      )}
      {/** Alerta de permisos */}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      <CustomTable
        {...{
          data: funcion,
          columns,
        }}
      />
    </Container>
  );
};

export default FuncionTable;
